import Messages from './Messages.js';
export default Messages;
//# sourceMappingURL=index.js.map